<template>
  <IonPageContainer>
    <TheAlertPage
      imageName="check-internet-connection.svg"
      alertTitle="No internet connection"
      alertMessage="Check your connection and try again."
      alertIcon="wifi-off"
      alertColor="warning"
    >
      <template #additionalContent>
        <CustomIonButton
          color="primary"
          :isDisabled="isRetrying"
          class="mt-3"
          @onClick="retryConnection"
        >
          <CustomRotatingIcon v-if="isRetrying" color="light" />
          <span class="ms-2">{{ isRetrying ? "Retrying..." : "Try Again" }}</span>
        </CustomIonButton>
        <CustomIonButton
          v-if="IsLoggedIn && !IsStudent"
          color="tertiary"
          class="mt-2"
          @onClick="gotoOfflineDownloads"
        >
          <i class="ti ti-cloud-download me-1"></i>
          <span>Go to Downloads</span>
        </CustomIonButton>
      </template>
    </TheAlertPage>
  </IonPageContainer>
</template>
<script lang="ts">
import IonPageContainer from "@/components/layout/IonPageContainer.vue";
import CustomIonButton from "@/components/primitives/CustomIonButton.vue";
import CustomRotatingIcon from "@/components/primitives/CustomRotatingIcon.vue";
import TheAlertPage from "@/components/states/TheAlertPage.vue";
import { useAppNavigation } from "@/methods/utils";
import { useSessionStore } from "@/stores/core/sessionStore";
import { onIonViewWillEnter, onIonViewWillLeave } from "@ionic/vue";
import { storeToRefs } from "pinia";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "CheckInternetConnection",
  components: {
    IonPageContainer,
    CustomIonButton,
    TheAlertPage,
    CustomRotatingIcon,
  },
  setup() {
    const { navigateTo } = useAppNavigation();
    const isRetrying = ref(false);
    const sessionStore = useSessionStore();
    const { IsLoggedIn, IsStudent } = storeToRefs(sessionStore);

    onIonViewWillEnter(() => {
      window.addEventListener("online", onOnline);
    });

    onIonViewWillLeave(() => {
      window.removeEventListener("online", onOnline);
    });

    async function retryConnection() {
      if (isRetrying.value) return;
      isRetrying.value = true;
      navigateTo({ name: "LandingPage" });
      isRetrying.value = false;
    }

    function gotoOfflineDownloads() {
      navigateTo({ name: "OfflineDownloads" });
    }

    function onOnline() {
      retryConnection();
    }

    return { IsLoggedIn, IsStudent, isRetrying, retryConnection, gotoOfflineDownloads };
  },
});
</script>
